<article class="flex flex-column">
  <section>
    <button pButton icon="fas fa-plus" class="p-button-info p-button-outlined" [pTooltip]="screen.actions.add"
      (click)="openModal()">
    </button>
  </section>

  <section class="inline-flex">
    <p-table #dt [value]="patients.content" [lazy]="true" (onLazyLoad)="lazyReadPatients($event)" [paginator]="true"
      [rows]="pageSize" [totalRecords]="patients.totalElements" [loading]="loading" dataKey="id" selectionMode="single"
      [(selection)]="patientSelected" (onRowSelect)="onRowSelect($event)" class="col-12 p-0">

      <ng-template pTemplate="colgroup" let-columns>
        <colgroup>
          <col [style.width.px]="125">
          <col [style.width.px]="175">
          <col>
          <col [style.width.px]="200">
        </colgroup>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th class="text-center" [attr.colspan]="2">{{screen.labels.document}}</th>
          <th>{{screen.labels.name}}</th>
          <th class="text-center" [attr.rowspan]="2">{{screen.labels.age}}</th>
        </tr>
        <tr>
          <th [attr.colspan]="2">
            <input pInputText type="text" name="dtDocumentFilter" [(ngModel)]="dtDocumentFilter"
              (input)="dt.filter(dtDocumentFilter, 'document', 'contains')">
          </th>
          <th>
            <input pInputText type="text" name="dtNameFilter" [(ngModel)]="dtNameFilter"
              (input)="dt.filter(dtNameFilter, 'fullName', 'contains')">
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-patient>
        <tr [pSelectableRow]="patient">
          <td>{{patient.documentTypeName}}</td>
          <td>{{patient.document}}</td>
          <td>{{patient.fullName}}</td>
          <td>
            <ms-string-split [toSplit]="patient.age" [isDate]="true"></ms-string-split>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="4">
            <span>{{screen.labels.emptyTable}}</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </section>

  <section class="align-self-end">
    <ms-table-paged-footer [page]="patients"></ms-table-paged-footer>
  </section>
</article>